/**
 * Global auth event bus using custom DOM events.
 *
 * Any code (inside or outside React) can call `emitSessionExpired()` when it
 * receives a 401 from the server.  AuthProvider subscribes to this event and
 * clears the cached user state so the UI immediately reflects the logged-out
 * state.
 */

const AUTH_SESSION_EXPIRED_EVENT = 'auth:session-expired';

/** Dispatch a session-expired event. Safe to call multiple times — the
 *  listener in AuthProvider deduplicates via its own state. */
export function emitSessionExpired() {
  window.dispatchEvent(new CustomEvent(AUTH_SESSION_EXPIRED_EVENT));
}

/** Subscribe to session-expired events. Returns an unsubscribe function. */
export function onSessionExpired(callback: () => void): () => void {
  window.addEventListener(AUTH_SESSION_EXPIRED_EVENT, callback);
  return () => window.removeEventListener(AUTH_SESSION_EXPIRED_EVENT, callback);
}
